export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result.replace(file.type, `file@${file.type.split('/').pop()}`))
    reader.onerror = (error) => reject(error)
  })
